import i18n from '../i18n'
import { Language } from './constants'

export const limitCharacters = (text: string, amountChar: number) =>
  text && text.length > amountChar ? `${text.substring(0, amountChar)}...` : text

export const treatExternalLocale = (lng: string) => {
  if (lng?.match(/^pt/)) {
    return Language.PT.toUpperCase()
  }
  return lng?.toUpperCase()
}

export function formatDate(timestamp: number): string {
  const date = new Date(timestamp)
  const day = date.getDate()
  const month = [
    `${i18n.t('months.jan')}`,
    `${i18n.t('months.feb')}`,
    `${i18n.t('months.mar')}`,
    `${i18n.t('months.apr')}`,
    `${i18n.t('months.may')}`,
    `${i18n.t('months.jun')}`,
    `${i18n.t('months.jul')}`,
    `${i18n.t('months.aug')}`,
    `${i18n.t('months.sep')}`,
    `${i18n.t('months.oct')}`,
    `${i18n.t('months.nov')}`,
    `${i18n.t('months.dec')}`
  ][date.getMonth()]
  const year = date.getFullYear()

  return `${day} ${month} ${year}`
}

export const treatLanguage = (lng: string) => {
  if (lng?.toLowerCase() === Language.PT.toLowerCase()) {
    return 'pt-br'
  }
  return lng?.toLowerCase()
}

export const generateUUID = () => {
  return 'xxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
    const randomValue = Math.floor(Math.random() * 16)
    const calculatedValue = character === 'x' ? randomValue : (randomValue % 4) + 8

    return calculatedValue.toString(16)
  })
}

export const clearURLQueryParams = () => {
  history.replaceState({}, '', location.pathname)
}

export const resetScroll = (x = 0, y = 0) => {
  const rootElement = document.getElementById('root') as HTMLDivElement

  window.scrollTo(x, y)
  rootElement?.scrollTo(x, y)
}

export const scrollToElement = (top = 0) => {
  const rootSPAElement = document.getElementById('root') as HTMLDivElement
  const rootSSRElement = document.getElementById('__next') as HTMLDivElement

  window.scrollTo({
    top,
    behavior: 'smooth'
  })

  rootSPAElement?.scrollTo({
    top,
    behavior: 'smooth'
  })

  rootSSRElement?.scrollTo({
    top,
    behavior: 'smooth'
  })
}
